/** ISO 4217 (any case). Falls back to GBP if invalid for Intl. */
export function formatCurrencyAmount(
  amount: number | undefined | null,
  currencyIso: string | null | undefined,
  options?: { maximumFractionDigits?: number }
): string {
  const raw = (currencyIso ?? "gbp").trim();
  const code = raw.length >= 3 ? raw.toUpperCase() : "GBP";
  const n = amount ?? 0;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      maximumFractionDigits: options?.maximumFractionDigits ?? 2,
    }).format(n);
  } catch {
    return `${code} ${n.toFixed(2)}`;
  }
}
